export enum EDailyTripTypes {
    Import = 1,
    Export = 2,
    Domestic = 3,
    ReturnEmpty = 4
}


// WEBPACK FOOTER //
// ./src/app/enums/daily-trip-types.ts